module.exports = __webpack_public_path__ + "images/landing_get_it_from_amazon.6817bfe513c470b6e96b05b31a00b251.png";